import { MenuItem, useDisclosure } from "@chakra-ui/react";
import { TbSettingsCode } from "react-icons/tb";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaModal } from "@nens/ranalib";

import { FilesAsUrlsExplanation } from "./components/files-as-urls-explanation";
import { FilesAsUrlsTable } from "./components/files-as-urls-table";

type FilesAsUrlsModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

function FilesAsUrlsModal({ isOpen, onClose }: FilesAsUrlsModalProps) {
  const intl = useIntl();

  return (
    <RanaModal
      isOpen={isOpen}
      onClose={onClose}
      topBar={intl.formatMessage({
        id: "connect_publication_modal.title_connect_publication",
        defaultMessage: "Connect to External Tools",
      })}
      maxW="4xl"
    >
      <FilesAsUrlsExplanation />
      <FilesAsUrlsTable />
    </RanaModal>
  );
}

export const PublicationFilesAsUrlsModal = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <MenuItem onClick={onOpen} icon={<TbSettingsCode />}>
        <FormattedMessage
          id="button.connect_publication"
          defaultMessage="Connect to External Tools"
        />
      </MenuItem>

      <FilesAsUrlsModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};
